import React, { FC, useCallback, useState } from "react";

import { Tooltip as StyledTooltip } from "@mzc-pdc/ui";
import theme from "@styles/theme";

const Tooltip = React.forwardRef((props, ref) => {
    const { maxWidth, color, ...restProps } = props;
    const maxWidthStyle = maxWidth ? { maxWidth: maxWidth } : {};
    return (
        <StyledTooltip
            color={color}
            componentsProps={{
                tooltip: {
                    sx: {
                        backgroundColor: color ?? theme.palette.greySecondary[600],
                        "& .MuiTooltip-arrow": {
                            color: color ?? theme.palette.greySecondary[600],
                        },
                        ...maxWidthStyle,
                    },
                },
            }}
            {...restProps}
            ref={ref}
        >
            {props.children}
        </StyledTooltip>
    );
});

export default Tooltip;
